import EpgPersistence from "../../../AAF/Nepg/EpgPersistence";
import AbstractRequestTask from "../AbstractRequestTask";
import { DOMAIN } from "./const";

class LiveEventsTask extends AbstractRequestTask{
    constructor(matchId, options = {}, version = "v1", acceptLanguage = "es-ES") {
        super();
        this.matchId = matchId;
        this.version = version;
        this.acceptLanguage = acceptLanguage;
        this.lastEventId = options.lastEventId || null;
        this.topics = options.topics || [];
        this.limit = options.limit || null;
        this.params = super.getParams();
        this.user_token = this.params.user_token;
    }

    getUrl() {
        const http = "https://";
        const domain = DOMAIN
        const path = `/services/sports/${this.version}/matches/${this.matchId}/live-events`;
        return `${http}${domain}${path}`;
    }

    getParams() {
        const params = super.getParams();
        delete params.format
        delete params.api_version
        delete params.user_token
        delete params.HKS
        delete params.device_id
        delete params.device_name
        delete params.device_so
        delete params.user_id

        if (this.lastEventId) 
            params.lastEventId = this.lastEventId;
        
        if (Array.isArray(this.topics) && this.topics.length > 0) 
            params.topics = this.topics.join(',');

        if (this.limit) 
            params.limit = this.limit;

        return {
            ...params,
        };
    }

    getHeaders() {
        return {
            'Authorization': `Bearer ${this.user_token}`,
            'Accept-Language': this.acceptLanguage
        }
    }

     getMethod() {
        return 'GET';
    }

    isValid(data) {
        if (!data || data.errors) {
            return false;
        }

        return true;
    }
}

export default LiveEventsTask;


// WEBPACK FOOTER //
// ./src/requests/tasks/sports/liveEventsTask.js